import { useFilters } from '../../context';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faBackspace } from '@fortawesome/pro-solid-svg-icons';
import { PulseButton, Checkbox } from 'src/components/PulseUI';

const FilterGroup = ({ group, name }) => {
  const { toggleFilter, clearFilters } = useFilters();

  if (!group.filters?.length) return null;

  return (
    <div className="flex flex-col pr-4">
      <div
        className="flex justify-between items-center mb-2 pr-1"
        data-testid="dataFilterTitle"
      >
        <span>{group.title}</span>
        <PulseButton
          variant="plain"
          color="neutral"
          size="sm"
          onClick={() => clearFilters(name)}
          className="text-neutral-600 uppercase text-[0.65rem] justify-end"
        >
          <span className="hidden lg:inline">Clear</span>
          <Icon icon={faBackspace} className="ml-1" />
        </PulseButton>
      </div>
      <div className="flex flex-col gap-1">
        {[...(group.filters || [])]
          .sort((a, b) => {
            return a.title < b.title ? -1 : 1;
          })
          .map(({ title, value: key, context }) => {
            const contextIdentifiersToInclude = {
              cpt: true,
              hcpcs: true,
              icd: true,
              drg: true,
              apc: true,
              icdp: true,
            };
            const includeContext = contextIdentifiersToInclude[context];
            const conditionalTrademark = context === 'cpt' ? '®' : '';
            const display = includeContext
              ? `${context.toUpperCase()}${conditionalTrademark}-${title}`
              : title;

            return (
              <Checkbox
                key={`${name}-${title}-${key}`}
                checked={group.selectedDict[key] || false}
                onChange={() => {
                  toggleFilter(name, key);
                }}
                id={`${name}-${title}-${key}`}
                size="sm"
                label={display}
                aria-label={`Filter by ${display}`}
                data-testid={`filter-checkbox-${name}-${key}`}
              />
            );
          })}
      </div>
    </div>
  );
};

export default FilterGroup;
